// @ts-nocheck


import React from 'react';
import moment from 'moment';
import { DatePicker } from '../../../../components/ant/DatePicker';
import { Button } from 'antd';

import CommonForm from

'../../../../components/hoc/common/handbook/CommonForm';
import Grid, { GridItem } from '../../../../components/layout/Grid';
import { FormField } from '../../../../components/Form';
import BudgetSummarySelect from '../../../../components/selects/BudgetSummarySelect';
import {
  budgetSummaryEnum,
  budgetSummaryStatus,
  entityStatusEnum } from
'../../../../lib/enum';
import {
  budgetSummaryInfoString,
  formatDateTimeToISOString,
  formatDateTimeToString } from
'../../../../lib/helpers';
import Select from '../../../../components/selects';
import Field from '../../../../components/card/Field';


const { BudgetVersionSelect } = Select;

export default (props) => {
  if (!props.data) return null;
  return (
    <CommonForm {...props} useFooter={false}>
      {({ values, setFieldValue, handleSubmit, dirty, isSubmitting }) => {
        const disabled = values.id !== 0;
        return (
          <>
            <Grid gutter="16px" cols={5}>
              <GridItem>
                <Field label="Статус">
                  <>{budgetSummaryStatus[values.status]}</>
                </Field>
              </GridItem>
              {values.type === budgetSummaryEnum.clarification &&
              <GridItem>
                  <FormField
                  label="Сводный бюджет"
                  required
                  name="mainSummaryId"
                  fast>

                    {({ value, name }) =>
                  disabled ?
                  budgetSummaryInfoString(values.mainSummary) :

                  <BudgetSummarySelect
                    value={value}
                    onChange={(value) => {
                      setFieldValue(name, value);
                    }}
                    filter={{
                      type: budgetSummaryEnum.main,
                      status: entityStatusEnum.approved
                    }} />


                  }
                  </FormField>
                </GridItem>
              }
              <GridItem>
                <FormField label="Дата формирования" required name="date" fast>
                  {({ name, value }) =>
                  disabled ?
                  formatDateTimeToString(value, 'DD.MM.YYYY') :

                  <DatePicker
                    format="DD.MM.YYYY"
                    value={value ? moment(value) : null}
                    onChange={(value, dateString) => {
                      setFieldValue(
                        name,
                        formatDateTimeToISOString(value, dateString)
                      );
                    }} />


                  }
                </FormField>
              </GridItem>
              <GridItem>
                <FormField
                  label="Версия бюджета"
                  required
                  name="budgetVersionId"
                  fast>

                  {({ name, value }) => {
                    return disabled ?
                    values.budgetVersion.name :

                    <BudgetVersionSelect
                      disabled={disabled}
                      placeholder="Версия бюджета"
                      onChange={(value) => setFieldValue(name, value)}
                      value={value}
                      filter={{}} />;


                  }}
                </FormField>
              </GridItem>
              {dirty &&
              <GridItem>
                  <Field label=" ">
                    <Button
                    type="primary"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    loading={isSubmitting}>

                      Сохранить
                    </Button>
                  </Field>
                </GridItem>
              }
            </Grid>
          </>);

      }}
    </CommonForm>);

};
